import { AiOutlineGold, AiOutlineInfoCircle } from 'react-icons/ai';
import { BiBuildings, BiCategory } from 'react-icons/bi';
import { BsBag, BsPersonVideo2 } from 'react-icons/bs';
import { FaHome, FaUserCheck, FaRegBuilding, FaUsers } from 'react-icons/fa';
import { FaArrowUpRightDots } from 'react-icons/fa6';
import { ImTree } from 'react-icons/im';
import { MdOutlineAnalytics, MdOutlineDataset, MdQueryStats, MdSegment } from 'react-icons/md';
import { RiAdminFill, RiArrowDownSFill, RiArrowUpSFill, RiCheckboxMultipleFill, RiGroupLine, RiShieldKeyholeLine } from 'react-icons/ri';
import { TbChartDots3, TbPlugConnected } from 'react-icons/tb';
import { TiFlowMerge } from 'react-icons/ti';
import { VscGitCompare } from 'react-icons/vsc';

export const menuItem = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <FaHome />,
    level: 0,
  },
  {
    path: '/domain',
    name: 'Domain',
    icon: <BiCategory />,
    level: 0,
  },
  {
    path: '/client',
    name: 'Client',
    icon: <BiBuildings />,
    level: 0,
  },
  {
    path: '/engagement',
    name: 'Engagement',
    icon: <ImTree />,
    level: 0,
  },
  // {
  //   path: '/data-model/asset360',
  //   name: 'Data Model',
  //   icon: <MdOutlineDataset />,
  //   dropDownClosed: <RiArrowDownSFill />,
  //   dropDownOpened: <RiArrowUpSFill />,
  //   level: 1,
  //   subNav: [
  //     {
  //       path: '/data-model/asset360',
  //       name: 'Asset 360',
  //       icon: <FaArrowUpRightDots />,
  //       level: 0,
  //     },
  //     {
  //       path: '/data-model/customer360',
  //       name: 'Customer 360',
  //       icon: <BsPersonVideo2 />,
  //       level: 0,
  //     },
  //     {
  //       path: '/data-model/company360',
  //       name: 'Company 360',
  //       icon: <BiBuildings />,
  //       level: 0,
  //     },
  //   ],
  // },
  {
    name: 'WorkFlow',
    icon: <TbChartDots3 />,
    path: '/workflow-cluster',
    dropDownClosed: <RiArrowDownSFill />,
    dropDownOpened: <RiArrowUpSFill />,
    level: 2,
    subNav: [
      {
        name: 'All Workflows',
        path: '/workflow-cluster',
        icon: <MdOutlineDataset />,
        level: 0,
      },
      {
        name: 'Asset 360',
        path: '/workflow-asset360-golden-records?processType=Asset 360',
        icon: <FaArrowUpRightDots />,
        dropDownClosed: <RiArrowDownSFill />,
        dropDownOpened: <RiArrowUpSFill />,
        level: 1,
        subNav: [
          {
            path: '/workflow-asset360-golden-records?processType=Asset 360',
            name: 'Golden Records',
            icon: <AiOutlineGold />,
            level: 0,
          },
          {
            path: '/workflow-asset360-segmentation?processType=Asset 360',
            name: 'Segmentation',
            icon: <MdSegment />,
            level: 0,
          },
          {
            path: '/workflow-asset360-analysis?processType=Asset 360',
            name: 'Analysis',
            icon: <MdOutlineAnalytics />,
            level: 0,
          },
        ],
      },
      {
        name: 'Customer 360',
        path: '/workflow-customer360-golden-records?processType=Customer 360',
        icon: <BsPersonVideo2 />,
        dropDownClosed: <RiArrowDownSFill />,
        dropDownOpened: <RiArrowUpSFill />,
        level: 1,
        subNav: [
          {
            path: '/workflow-customer360-golden-records?processType=Customer 360',
            name: 'Golden Records',
            icon: <AiOutlineGold />,
            level: 0,
          },
          {
            path: '/workflow-customer360-segmentation?processType=Customer 360',
            name: 'Segmentation',
            icon: <MdSegment />,
            level: 0,
          },
          {
            path: '/workflow-customer360-analysis?processType=Customer 360',
            name: 'Analysis',
            icon: <MdOutlineAnalytics />,
            level: 0,
          },
        ],
      },
      {
        name: 'Company 360',
        path: '/workflow-company360-golden-records?processType=Company 360',
        icon: <FaRegBuilding />,
        dropDownClosed: <RiArrowDownSFill />,
        dropDownOpened: <RiArrowUpSFill />,
        level: 1,
        subNav: [
          {
            path: '/workflow-company360-golden-records?processType=Company 360',
            name: 'Golden Records',
            icon: <AiOutlineGold />,
            level: 0,
          },
          {
            path: '/workflow-company360-segmentation?processType=Company 360',
            name: 'Segmentation',
            icon: <MdSegment />,
            level: 0,
          },
          {
            path: '/workflow-company360-analysis?processType=Company 360',
            name: 'Analysis',
            icon: <MdOutlineAnalytics />,
            level: 0,
          },
        ],
      },
    ],
  },
  {
    path: '/users',
    name: 'Admin Console',
    icon: <RiAdminFill />,
    dropDownClosed: <RiArrowDownSFill />,
    dropDownOpened: <RiArrowUpSFill />,
    level: 1,
    subNav: [
      // {
      //   path: '/approval',
      //   name: 'Approvals',
      //   icon: <RiCheckboxMultipleFill />,
      //   level: 0,
      // },
      // {
      //   path: '/user-management',
      //   name: 'User Management',
      //   icon: <FaUserCheck />,
      //   level: 0,
      // },
      {
        path: '/users',
        name: 'Users',
        icon: <FaUsers />,
        level: 0,
      },
      {
        path: '/roles-permissions',
        name: 'Roles & Permissions',
        icon: <RiShieldKeyholeLine />,
        level: 0,
      },
      {
        path: '/groups',
        name: 'Groups',
        icon: <RiGroupLine />,
        level: 0,
      },
      {
        path: '/connectors',
        name: 'Connectors',
        icon: <TbPlugConnected />,
        level: 0,
      },
      {
        path: '/llm',
        name: 'LLM',
        icon: <MdQueryStats />,
        level: 0,
      },
    ],
  },
  {
    path: '/about',
    name: 'About',
    icon: <AiOutlineInfoCircle />,
    level: 0,
  },
];

export const menuItemV1 = [
  {
    path: '/dashboard',
    name: 'Dashboard',
    icon: <FaHome />,
    level: 0,
  },
  {
    path: '/client',
    name: 'Client',
    icon: <BiBuildings />,
    level: 0,
  },
  {
    path: '/engagement',
    name: 'Engagement',
    icon: <ImTree />,
    level: 0,
  },
  {
    path: '/data-model-asset360',
    name: 'Data Model',
    icon: <MdOutlineDataset />,
    dropDownClosed: <RiArrowDownSFill />,
    dropDownOpened: <RiArrowUpSFill />,
    level: 1,
    subNav: [
      {
        path: '/data-model-asset360',
        name: 'Asset 360',
        icon: <FaArrowUpRightDots />,
        level: 0,
      },
      {
        path: '/data-model-customer360',
        name: 'Customer 360',
        icon: <BsPersonVideo2 />,
        level: 0,
      },
      {
        path: '/data-model-company360',
        name: 'Company 360',
        icon: <BiBuildings />,
        level: 0,
      },
    ],
  },

  {
    // path: '/workflow-data',
    name: 'WorkFlow',
    icon: <TbChartDots3 />,
    dropDownClosed: <RiArrowDownSFill />,
    dropDownOpened: <RiArrowUpSFill />,
    level: 1,
    subNav: [
      {
        path: '/workflow-data',
        name: 'All Workflows',
        icon: <BsBag />,
        level: 0,
      },
      {
        path: '/workflow-ingestion',
        name: 'Data Ingestion',
        icon: <TiFlowMerge />,
        level: 0,
      },
      {
        path: '/workflow-data-transformation',
        name: 'Data Transformation',
        icon: <VscGitCompare />,
        level: 0,
      },
    ],
  },
  {
    path: '/about',
    name: 'About',
    icon: <AiOutlineInfoCircle />,
    level: 0,
  },
];
